import HeroText from "./HeroText";
import HeroVisual from "./HeroVisual";

function Hero() {
  return (
    <div id="top" className="grid-bg">
      <div className="wrap hero">
        <div className="hero-grid">
          <HeroText />
          <HeroVisual />
        </div>
      </div>
    </div>
  );
}

export default Hero;
